import React from 'react';
import { StyledTag, StyledTooltip, TooltipDeclineBody } from './tag.styles';
import { IconPerceptionDisorder } from '../../icon/icon-perception-disorder/icon-perception-disorder';
import { TagProps } from './types';
import { DeclineComment } from '../decline-comment/decline-comment';

export const Tag: React.FC<TagProps> = ({ declineMessage, variant = 'blue', children, ...props }) => {
    if (variant === 'declined') {
        return (
            <StyledTooltip {...props}>
                <StyledTag variant='red' icon={<IconPerceptionDisorder />}>
                    {children}
                </StyledTag>
                {declineMessage && (
                    <TooltipDeclineBody>
                        <DeclineComment
                            avatarUrl={declineMessage.managerAvatarUrl}
                            name={declineMessage.managerName}
                            message={declineMessage.message}
                        />
                    </TooltipDeclineBody>
                )}
            </StyledTooltip>
        );
    }

    return <StyledTag variant={variant}>{children}</StyledTag>;
};
